import Vue from 'vue'
import components from './components/'

const getProps = (el) => {
  const list = []
  const pattern = /^data\-/
  Array.from(el.attributes)
    .forEach((attr) => {
      if (pattern.test(attr.name)) {
        list.push({
          key: attr.name.replace(pattern, ''),
          value: attr.value
        })
      }
    })
  return list.map((item) => {
    return `${item.key}="${item.value}"`
  }).join(' ')
}

Array.from(document.querySelectorAll('[view]'))
  .forEach((el) => {
    const name = el.getAttribute('view')
    if (name in components) {
      const props = getProps(el)
      new Vue({
        el,
        components,
        template: `<${name} ${props}></${name}>`
      })
    }
  })



// WEBPACK FOOTER //
// ./src/main.js